var rich_content_viewer_default = {
  "fontElementMap": "MRebn",
  "wrapper": "m6AOT",
  "pluginContainerMobile": "_0h0Bf",
  "viewer": "uSiJi",
  "android": "oD--B",
  "rootedTraversedContent": "X6Wo9",
  "atomic": "quQLL",
  "toolbar": "Qbxzg",
  "block": "_54I9V"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
